import { useSelector } from "react-redux";
import { FilterTemplate } from "./FilterTemplate";

interface TagFilterProps {
	innerRef: React.RefObject<{
		getFilters: () => string[];
	}>;
	handleApply: () => void;
}

export const TagFilter: React.FC<TagFilterProps> = ({ innerRef, handleApply }) => {
	const tags = useSelector((state) => state?.libraries?.tags || []);

	return <FilterTemplate innerRef={innerRef} records={tags} title="TAGS" icon="tag" handleApply={handleApply} />;
};
